const tichengPage2 = () => import('@/views/main/performance-commission/ticheng2/ticheng.vue')
export default {
  path: '/main/tichengPage2',
  name: 'tichengPage2',
  component: tichengPage2,
  children: []
}
